import { Modal, Button, Spinner } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import "./EditVideo.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showToast } from "../ShowToast/ToastNotification";
import {  useNavigate } from 'react-router-dom';

const EditVideo = ({ parentfetchVideo }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lesson_id = searchParams.get("lesson_id");
  const video_id = searchParams.get("video_id");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    video: null,
    language: "en",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Fetch existing video data
  const fetchVideos = async () => {
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/lessons/${lesson_id}/videos/${video_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        showToast(t("errorFetchingVideoDetails"), "error");
        return;
      }
  
      const result = await response.json();
  
      // ✅ Access nested data
      const videoData = result.data;
  
      setFormData({
        video: null,
        language: videoData.language || "en",
      });
  
    } catch (err) {
      console.error("Unexpected error:", err);
      showToast(t("somethingWentWrong"), "error");
    }
  };
  

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ✅ Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      video: file,
    });
  };

  // ✅ Validate form before submitting
  const validateForm = () => {
    let newErrors = {};
    if (!formData.language) {
      newErrors.language = t("Language is required");
    }
    if (!formData.video) {
      newErrors.video = t("Video file is required");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Submit updated video
const handleUpdatevideo = async (e) => {
    e.preventDefault();
  
    // 🔸 Form validation
    if (!validateForm()) {
      showToast(t("Please fix the errors before submitting"), "error");
      return;
    }
  
    setIsLoading(true);
  
    try {
      const token = localStorage.getItem("userToken");
      const form = new FormData();
      form.append("language", formData.language);
      form.append("video", formData.video);
  
      const response = await fetch(
        `${api_url}/lessons/${lesson_id}/videos/${video_id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        }
      );
  
      const resData = await response.json();
  
      if (response.ok && resData.status === "success") {
        showToast(resData.message || t("videoUpdateSuccess"), "success");
        setErrors({});
  
        try {
          await parentfetchVideo("");
        } catch (fetchErr) {
          console.error("Error in parentfetchVideo:", fetchErr);
        }
        navigate(-1);

        return; 
      }
  
      if (resData?.errors) {
        setErrors(resData.errors);
        Object.values(resData.errors)
          .flat()
          .forEach((msg) => {
            showToast(msg, "error");
          });
      } else {
        showToast(resData.message || t("videoUpdateFailed"), "error");
      }
  
    } catch (error) {
      console.error("Unexpected error updating video:", error);
      showToast(t("unexpectedError"), "error");
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div
      className="py-4"
      style={{
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        padding: "0px 15px",
      }}
    >
      <div className="row">
        {/* Language Field */}
        <div className="mb-3">
          <label className="form-label">{t("Language")}</label>
          <select
            className={`form-select ${errors.language ? "is-invalid" : ""}`}
            aria-label="Language"
            name="language"
            onChange={handleChange}
            value={formData.language}
          >
            <option value="en">{t("English")}</option>
            <option value="ar">{t("Arabic")}</option>
          </select>
          {errors.language && (
            <div className="invalid-feedback">
              {Array.isArray(errors.language)
                ? errors.language.join(", ")
                : errors.language}
            </div>
          )}
        </div>

        {/* Video Upload Field */}
        <div className="mb-3">
          <label className="form-label">{t("Video")}</label>
          <input
            type="file"
            className={`form-control ${errors.video ? "is-invalid" : ""}`}
            accept="video/*"
            onChange={handleFileChange}
          />
          {errors.video && (
            <div className="invalid-feedback">
              {Array.isArray(errors.video)
                ? errors.video.join(", ")
                : errors.video}
            </div>
          )}
        </div>
      </div>

      <button
        type="submit"
        className="btn btn-primary"
        disabled={isLoading}
        onClick={handleUpdatevideo}
      >
        {isLoading ? (
          <>
            <Spinner animation="border" size="sm" role="status" className="me-2" />
            {t("Update...")}
          </>
        ) : (
          t("UpdateVideo")
        )}
      </button>
    </div>
  );
};

export default EditVideo;
